<template>
  <header class="site-header">
    <div class="header-content">
      <!-- Logo -->
      <div class="logo-container">
        <img src="@/assets/logoDNWAYS_GREEN.png" alt="Logo" class="logo" />
      </div>

      <!-- Botão Voltar (opcional) -->
      <button v-if="showBackButton" class="btn-back" @click="handleBack">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 16l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Voltar</span>
      </button>

      <!-- Título -->
      <h1 class="header-title">{{ title }}</h1>

      <!-- Menu Admin -->
      <div v-if="user?.isAdminDNWAYS" class="admin-menu">
        <button class="btn-admin" @click="toggleMenu">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>Admin</span>
        </button>
        <div v-if="menuAberto" class="dropdown-menu">
          <router-link to="/" class="menu-item">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="2" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.5"/>
              <rect x="10" y="2" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.5"/>
              <rect x="2" y="10" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.5"/>
              <rect x="10" y="10" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.5"/>
            </svg>
            Dashboard
          </router-link>
          <router-link to="/empresas" class="menu-item">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="3" width="14" height="12" rx="1" stroke="currentColor" stroke-width="1.5"/>
              <path d="M6 7h6M6 10h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            Empresas
          </router-link>
        </div>
      </div>

      <!-- Informações do Usuário -->
      <div class="user-info">
        <div class="user-avatar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="2"/>
            <path d="M4 20c0-4 3.5-6 8-6s8 2 8 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="user-details">
          <span class="user-name">{{ userName }}</span>
          <span class="user-email">{{ userEmail }}</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true,
      default: 'Dashboard'
    },
    showBackButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuAberto: false
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    userName() {
      return this.user?.nomeUsuario || this.user?.NomeUsuario || 'Usuário';
    },
    userEmail() {
      return this.user?.email || this.user?.Email || 'email@exemplo.com';
    }
  },
  mounted() {
    // Fecha o menu ao clicar fora
    document.addEventListener('click', this.fecharMenuAoClicarFora);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.fecharMenuAoClicarFora);
  },
  methods: {
    handleBack() {
      this.$emit('back');
    },
    toggleMenu() {
      this.menuAberto = !this.menuAberto;
    },
    fecharMenuAoClicarFora(event) {
      const adminMenu = this.$el?.querySelector('.admin-menu');
      if (adminMenu && !adminMenu.contains(event.target)) {
        this.menuAberto = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

/* Header */
.site-header {
  background: linear-gradient(135deg, #00235C 0%, #001a45 100%);
  padding: 1.5rem 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

/* Logo */
.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.logo {
  height: 45px;
  width: auto;
  filter: brightness(0) invert(1);
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
}

.header-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: white;
  margin: 0;
  flex: 1;
  text-align: center;
  letter-spacing: -0.5px;
}

/* Botão Voltar */
.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateX(-3px);
  }

  svg {
    flex-shrink: 0;
  }
}

/* Menu Admin */
.admin-menu {
  position: relative;
}

.btn-admin {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  background: rgba(14, 165, 233, 0.2);
  color: white;
  border: 1px solid rgba(14, 165, 233, 0.3);
  border-radius: 10px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background: rgba(14, 165, 233, 0.3);
    border-color: rgba(14, 165, 233, 0.4);
  }

  svg {
    flex-shrink: 0;
  }
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  min-width: 200px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 1000;
  animation: slideDown 0.2s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  color: #374151;
  font-size: 0.9375rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f9fafb;
    color: #00235C;
  }

  &.router-link-active {
    background: #f0f9ff;
    color: #0ea5e9;
    font-weight: 600;
  }

  svg {
    flex-shrink: 0;
  }
}

/* Informações do Usuário */
.user-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
  }
}

.user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: white;
  flex-shrink: 0;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.user-name {
  font-size: 0.9375rem;
  font-weight: 600;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-email {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Responsividade */
@media (max-width: 768px) {
  .site-header {
    padding: 1rem 1.5rem;
  }

  .logo {
    height: 38px;
  }

  .header-title {
    font-size: 1.25rem;
  }

  .btn-back {
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;

    span {
      display: none;
    }
  }

  .user-details {
    max-width: 120px;
  }

  .user-name {
    font-size: 0.875rem;
  }

  .user-email {
    font-size: 0.7rem;
  }
}

@media (max-width: 480px) {
  .site-header {
    padding: 0.875rem 1rem;
  }

  .logo {
    height: 32px;
  }

  .header-title {
    font-size: 1.125rem;
  }

  .btn-back {
    padding: 0.5rem;
  }

  .user-info {
    padding: 0.5rem;
  }

  .user-avatar {
    width: 32px;
    height: 32px;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  .user-details {
    display: none;
  }
}
</style>
